/**
 * PATH: packages/email-hub/src/feature/components/EmailPreviewPane.tsx
 * FILE_ID: EMAILHUB-FEATURE-COMPONENTS-EMAILPREVIEWPANE-001
 * PURPOSE: Assemble the canonical split-pane email reader from typed modules.
 * WHY: Tenants consume this stable default and named-prop export surface.
 */
import { PreviewOverlays } from './email-preview-pane/PreviewOverlays'
import { PreviewHeader } from './email-preview-pane/PreviewHeader'
import { PreviewReadingSurface } from './email-preview-pane/PreviewReadingSurface'
import { PreviewWholeHeader } from './email-preview-pane/PreviewWholeHeader'
import { useEmailPreviewPane } from './email-preview-pane/useEmailPreviewPane'
import type { EmailPreviewPaneProps } from './email-preview-pane/types'
import { isEmailHubFeatureEnabled } from '../../_internal/flags'

export type { EmailPreviewPaneProps } from './email-preview-pane/types'

export default function EmailPreviewPane(props: EmailPreviewPaneProps) {
  const { headerProps, readingProps, overlayProps } =
    useEmailPreviewPane(props)
  const wholeHeaderEnabled = isEmailHubFeatureEnabled('wholeReaderHeader')

  return (
    <div
      className="flex flex-col h-full"
      style={{ backgroundColor: 'var(--email-card, var(--background))' }}
    >
      {wholeHeaderEnabled ? (
        <PreviewWholeHeader header={headerProps} reading={readingProps} />
      ) : (
        <PreviewHeader {...headerProps} />
      )}
      <PreviewReadingSurface {...readingProps} />
      <PreviewOverlays {...overlayProps} />
    </div>
  )
}
